module.exports = __webpack_public_path__ + "media/auto_history/kupno-ce45a9e8.svg";